export default function Navbar({ title, theme, onToggleTheme, onLogout, onToggleSidebar }) {
  return (
    <nav className="topbar">
      <div className="topbar-left">
        <button type="button" className="hamburger-btn" onClick={onToggleSidebar} aria-label="Toggle Sidebar">
          ☰
        </button>
        <div>
          <p className="eyebrow">Admin workspace</p>
          <h1>{title}</h1>
        </div>
      </div>
      <div className="topbar-actions">
        <button type="button" onClick={onToggleTheme}>{theme === 'dark' ? '⚙️ Light' : '🌙 Dark'}</button>
        <button type="button" onClick={onLogout}>Logout</button>
      </div>
    </nav>
  );
}

